import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ContactList } from '../../contacts/contact-list.model';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { Router } from '@angular/router';
import { CustomFieldJSON } from '../../contacts/contact-list-assign/contact-list-assign.component';
import { Contact } from '../../contacts/contact/contact.model';
import { MappedTableCells, MapTableCellsComponent } from './map-table-cells/map-table-cells.component';
import { UploadedTable, SelectedContactList } from './upload-file-select-contactlist/upload-file-select-contactlist.component';
import { MessageDialogComponent } from '../../core/message-dialog/message-dialog.component';
import { MessageType } from '../../core/message-dialog/message-type.enum';
import { DisplayTableWithFlagsComponent } from './display-table-with-flags/display-table-with-flags.component';
import { DisplaySuccessImportComponent } from './display-success-import/display-success-import.component';
import { AntiForgeryTokenService } from '../../auth/anti-forgery-token.service';
import { SubSink } from 'subsink';
import { UserCompanyService } from '../../nav-menu/user-company.service';
import { Title } from '@angular/platform-browser';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'import-files',
  templateUrl: './import-files.component.html',
  styleUrls: ['./import-files.component.css']
})

export class ImportFilesComponent implements OnInit, OnDestroy {
  private sheetTable: object[] = [];
  private tableHeader: string[] = [];
  private copySheetTable: object[] = [];
  private copyTableHeader: string[] = [];
  private originalSheetTable: object[] = [];
  private wizardContainer: any;
  private wizard: any;
  private contactList: ContactList[] = [];
  private contact: Contact[] = [];
  private customFieldName: string[] = [];
  private recievedContacts: Contact[] = [];
  private customFieldArrFromImortedData: CustomFieldJSON[] = [];
  private contactContactListArrFromImportedData: ContactContactList[] = [];
  private seletedTableHeaders: string[] = [];
  private customFieldBySelectedContactList: CustomFieldJSON[] = [];
  private idContactList: number;
  private renamedObjProp: string[] = [];
  private existingContacts: boolean[] = [];
  private haveErrors: boolean = false;
  private isImported: boolean = false;
  private selectedCompany: number;
  private subs = new SubSink();

  @ViewChild('mapTable', { static: false }) mapTableCells: MapTableCellsComponent;
  @ViewChild('tableWithflags', { static: false }) tableWithflags: DisplayTableWithFlagsComponent;
  @ViewChild('successImportTable', { static: false }) successImportTable: DisplaySuccessImportComponent;
  @ViewChild('msgDialog', { static: false }) msgDialog: MessageDialogComponent;

  constructor(private repository: HttpRepositoryService, private router: Router,
    private antiForgery: AntiForgeryTokenService,
    private companyService: UserCompanyService,
    private titleService: Title) { }

  ngOnInit(): void {
    let that = this;
    this.subs.sink = this.companyService.currentSelectedCompanyCode.subscribe(resp => {
      this.titleService.setTitle("Link.Maketer - " + resp);
    });

    this.wizardContainer = $('#wizard');

    this.subs.sink = this.companyService.currentSelectedCompany.subscribe(cmpRes => {
      this.selectedCompany = cmpRes;

      this.subs.sink = this.repository.get<ContactList[]>('api/ContactList/GetContactLists?id=' + this.selectedCompany).subscribe(resp => {
        if (resp.hasErrors) {
          Toast.Show(resp.error, 'Load Contact list', 'error')
        } else {
          this.contactList = resp.data;
        }
      });
    });


    let wOptions = {
      title: 'Import Contacts',
      size: 'large',
      finishButton: {
        text: 'Import',
        class: 'btn btn-success',
        closeWizard: true
      },
      nextButton: {
        text: 'Next',
        class: 'btn btn-primary'
      },
      previousButton: {
        text: 'Previous',
        class: 'btn btn-light'
      },
      stepper: {
        visible: true,
        useIcons: true
      },
      verticalAlign: 'top',
      animation: true,
      closeButtonVisible: true,
      noModal: true,
      onPageChanging: function (current, next, cancel) {
        if (current == 0 && next == 1) {
          if (that.tableHeader.length < 1) {
            that.msgDialog.show('Please upload file first.', MessageType.OK, 'Upload File conformation.');
            cancel(true);
          } else if (that.customFieldName.length < 2) {
            that.msgDialog.show('Please select contact list.', MessageType.OK, 'Upload File conformation.');
            cancel(true);
          } else {
            that.mapTableCells.show(that.customFieldName, that.tableHeader);
            cancel(false);
          }
        }

        if (current == 1 && next == 2) {
          if (that.mapTableCells.save()) {
            that.addErrorFlag();
            that.addExistFlag();

            cancel(false);
          } else {
            cancel(true);
          }
        }

        if (next < current) {
          if (next == 1 && current == 2) {
            that.copySheetTable = JSON.parse(JSON.stringify(that.originalSheetTable));
            cancel(false);
          }

          cancel(false);
        }
      },
      onFinishing: function (cancel) {
        if (that.haveErrors) {
          that.msgDialog.show('There are errors in uploaded table, click YES if you want to import only correct rows or NO if you want to close', MessageType.YESNO, 'Import contacts conformation.', () => {
            that.filterCorrectRowsInTable();
          });
        } else {
          that.createContactsAndAssignToContactList();
        }
      }
    }

    this.wizard = this.wizardContainer.Wizard(wOptions);
  }

  private createContactsAndAssignToContactList() {
    let that = this;

    this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {
        Toast.Show(afResp.error, 'Import contacts', 'error');
      } else {
        this.subs.sink = this.repository.post<Contact[]>('api/Contact/ListCreate?companyId=' + this.selectedCompany, this.contact, afResp.data).subscribe(resp => {
          let importCustomField: CustomFieldJSON;

          if (resp.hasErrors) {
            Toast.Show(resp.error, 'Import contacts', 'error');
          } else {
            this.recievedContacts = resp.data;

            this.sheetTable.forEach((obj, index) => {
              that.customFieldBySelectedContactList.forEach(field => {
                for (let property in obj) {
                  if (field.name === property) {
                    importCustomField = new CustomFieldJSON(field.idCustomField, obj[property], field.type, field.name, field.isRequired);
                    that.customFieldArrFromImortedData.push(importCustomField);
                  }
                }

                let idContact = that.recievedContacts[index].id;
                let customFieldJson: string = JSON.stringify(that.customFieldArrFromImortedData);
                that.contactContactListArrFromImportedData[index] = new ContactContactList(idContact, that.idContactList, customFieldJson);
              });

              //if there is no custom fields in contact list
              if (that.customFieldBySelectedContactList.length == 0) {
                let idContact = that.recievedContacts[index].id;
                let customFieldJson: string = "[]";
                that.contactContactListArrFromImportedData[index] = new ContactContactList(idContact, that.idContactList, customFieldJson);
              }

              that.customFieldArrFromImortedData = [];
            });
          }

          this.subs.sink = this.repository.post<ContactContactList[]>('api/Contact/Assign', this.contactContactListArrFromImportedData, afResp.data).subscribe(resp => {

            if (resp.hasErrors) {
              Toast.Show(resp.error, 'Assign contacts to contact list', 'error');
            } else {
              Toast.Show('Total ' + resp.data.length + ' contacts has been imported successfully.', 'Import contacts to contact list', 'success');
              this.isImported = true;
              this.successImportTable.show(this.sheetTable);
              this.hideButtons();
            }
          });
        });
      }
    });
  }

  private onUploadedTable(data: UploadedTable) {
    this.sheetTable = data.sheetTable;
    this.tableHeader = data.tableHeader;

    this.originalSheetTable = JSON.parse(JSON.stringify(this.sheetTable)) // original untouched table
    this.copySheetTable = JSON.parse(JSON.stringify(this.sheetTable)); //deep copy
    this.copyTableHeader = Object.keys(this.copySheetTable[0]).map(x => x);
  }

  private onSelectedContacList(data: SelectedContactList) {
    this.idContactList = data.idContactList;
    this.customFieldName = data.customFieldName;
    this.customFieldBySelectedContactList = data.customFieldBySelectedContactList;
  }

  private onResetTable(isReseted: boolean) {
    if (isReseted) {
      this.sheetTable = [];
      this.tableHeader = [];
      this.customFieldName = [];
      this.copySheetTable = [];
      this.copyTableHeader = [];
      this.originalSheetTable = [];
    }
  }

  private mapSelectedFields(contactAndContactListKeys: string[], selectedTableFields: string[]) {
    this.renameObjProp(contactAndContactListKeys, selectedTableFields);
    this.createContactArr();
  }

  private renameObjProp(classKeys: string[], selectedTableFields: string[]) {
    this.sheetTable.forEach(obj => {
      for (let i = 0; i < selectedTableFields.length; i++) {
        for (let key in obj) {
          if (key == selectedTableFields[i] && key !== classKeys[i]) {
            Object.defineProperty(obj, classKeys[i], Object.getOwnPropertyDescriptor(obj, key));
            delete obj[key];
          }
        }
      }
    });
  }

  private createContactArr() {
    if (this.contact.length > 0)
      this.contact = [];

    this.sheetTable.forEach(obj => {
      let importedContact = new Contact();
      importedContact.email = obj['Email'];
      importedContact.phone = obj['Phone'];

      this.contact.push(importedContact);
    });
  }

  private onSelectedColumns(data: MappedTableCells) {
    this.renamedObjProp = [];
    this.seletedTableHeaders = data.selectedTableHeaders;
    this.mapSelectedFields(data.contactAndContactListKeys, data.selectedTableHeaders);
    this.renamedObjProp.unshift(...data.selectedTableHeaders);
  }

  private addExistFlag() {
    this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {
        Toast.Show(afResp.error, 'Import contacts', 'error');
      } else {
        this.subs.sink = this.repository.post<boolean[]>('api/Contact/Exists?companyId=' + this.selectedCompany, this.contact, afResp.data).subscribe(resp => {
          this.existingContacts = resp.data;

          if (this.copyTableHeader.indexOf('exists') == -1)
            this.copyTableHeader.push('exists');

          this.copySheetTable.forEach((obj, index) => {
            if (this.existingContacts[index] == true) {
              obj['exists'] = '<i class="fas fa-exclamation-circle text-danger" data-toggle="tooltip" data-placement="top" title="This contact already exists"></i>';
              this.haveErrors = true;
            } else {
              obj['exists'] = null;
            }
          });

          this.tableWithflags.show(this.copySheetTable, this.copyTableHeader);
        });
      }
    });
  }


  private addErrorFlag() {
    this.copySheetTable.forEach((obj, index) => {

      if (obj.hasOwnProperty(this.renamedObjProp[0]) || obj.hasOwnProperty(this.renamedObjProp[1])) { //email or phone
        if (obj[this.renamedObjProp[0]] != null && !this.validateEmail(obj[this.renamedObjProp[0]])) {
          let value = obj[this.renamedObjProp[0]]
          obj[this.renamedObjProp[0]] = '<i class="fas fa-exclamation-circle text-danger" data-toggle="tooltip" data-placement="top" title="Email is not valid"></i> ' + value;
          this.haveErrors = true;
        }

        if (obj[this.renamedObjProp[1]] != null && !obj[this.renamedObjProp[1]].startsWith('+')) {
          let value = obj[this.renamedObjProp[1]];
          obj[this.renamedObjProp[1]] = '<i class="fas fa-exclamation-circle text-danger" data-toggle="tooltip" data-placement="top" title="Phone number must start with\'+\'"></i> ' + value;
          this.haveErrors = true;
        }

        if (obj[this.renamedObjProp[0]] == null && obj[this.renamedObjProp[1]] == null) {
          obj[this.renamedObjProp[0]] = '<i class="fas fa-exclamation-circle text-danger" data-toggle="tooltip" data-placement="top" title="Email or phone are required"></i>';
          obj[this.renamedObjProp[1]] = '<i class="fas fa-exclamation-circle text-danger" data-toggle="tooltip" data-placement="top" title="Email or phone are required"></i>';
          this.haveErrors = true;
        }
      }

      for (let property in obj) {
        this.customFieldBySelectedContactList.forEach(field => {
          if (field.isRequired && obj[property] == null) {
            for (let i = 2; i < this.renamedObjProp.length; i++) { //skip email and phone
              if (this.renamedObjProp[i] === property) {
                this.copySheetTable[index][property] = '<i class="fas fa-exclamation-circle text-danger" data-toggle="tooltip" data-placement="top" title="Required field"></i>';
                this.haveErrors = true;
              }
            }
          }
        });
      }

    });
  }

  private filterCorrectRowsInTable() {
    let indexOfFilterTable: number[] = [];
    let that = this;

    this.copySheetTable.forEach((obj, index) => {
      for (let property in obj) {
        if (obj[property] == null) {
          continue;
        } else {
          if (this.copySheetTable[index][property].indexOf('data-toggle="tooltip"') !== -1) {
            if (indexOfFilterTable.indexOf(index) === -1) {
              indexOfFilterTable.push(index);
            }
          }
        }
      }
    });

    let filteredSheetTable = this.sheetTable.filter((obj, ind) => {
      if (indexOfFilterTable.indexOf(ind) === -1) {
        return that.sheetTable[ind];
      }
    });

    let filteredContacts = this.contact.filter((obj, ind) => {
      if (indexOfFilterTable.indexOf(ind) === -1) {
        return that.contact[ind];
      }
    });

    this.sheetTable = filteredSheetTable;
    this.contact = filteredContacts;

    if (this.sheetTable.length < 1 || this.contact.length < 1) {
      Toast.Show('There is no valid row in uploaded table!', 'Import contacts', 'error');
    } else {
      this.createContactsAndAssignToContactList();
    }
  }

  private validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  private hideButtons() {
    $('.card.container-fluid').hide();
    $('.fa-file-import').closest('.stepper-item.active').removeClass('active').addClass('finished');
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}

export class ContactContactList {
  idContact: number;
  idContactList: number;
  customFieldsJson: string;

  constructor(idContact: number, idContactList: number, customFieldsJson: string) {
    this.idContact = idContact;
    this.idContactList = idContactList;
    this.customFieldsJson = customFieldsJson;
  }
}
